import React, {useState, useEffect} from 'react'
import {captureEvent} from 'event-service/modules/capture'

import "../../../contact/ContactForm.scss"
import view from "../calculator.module.scss"
import grid from "../../../../scss/flexboxgrid.module.scss"

export default function EstimatePayment(props) {
  const { price, month, months } = props
  const { values, setValues } = props
  const { vehicleInfo } = props

  const [engagement, setEngagement] = useState(false)

  useEffect(() => {
    if (engagement) {
      captureEvent({
        event: 'asc_form_engagement',
        comm_type: 'form',
        comm_status: 'start',
        element_text: engagement?.innerText,
        department: 'sales',
        form_name: 'Financing Calculator',
        form_type: 'sales',
        item_id:  vehicleInfo.VIN,
        item_number: `${vehicleInfo.Year} ${vehicleInfo.Make} ${vehicleInfo.Model} ${vehicleInfo.Trim}`,
        item_price: `${price}`,
        item_condition: `${vehicleInfo.IsNew ? 'New' : 'Used'}`,
        item_year: vehicleInfo.Year,
        item_make: vehicleInfo.Make,
        item_model: vehicleInfo.Model,
        item_variant: vehicleInfo.Trim,
        item_color: vehicleInfo.ExteriorColor,
        item_type:'vehicle',
        item_category: vehicleInfo.BodyType,
        item_fuel_type: vehicleInfo.EngineFuelType,
        item_inventory_date: vehicleInfo.InStockDate,
      }, {
        handlers: ['ASC']
      }).then(res => console.log(res)).catch(err => console.log(err)).finally(() => {engagement?.innerText === "Apply Now" && props.nextPage()})
    }
  }, [engagement])

  const updateState = (value, name) => {
    setValues({ ...values, [name]: value })
  }

  const updateTradein = (e) => {
    const value = price - (price * props.percentage / 100) - 100
    const tradein = Math.ceil(Math.min(Math.max(parseFloat(e.target.value), 0), value))
    setValues({ ...values, tradein })
  }

  const updateMonths = (months) => {
    props.slider.current.slickGoTo(months)
    setValues({ ...values, months })
  }

  const updateDownpayment = (_downpayment) => {
    const downpayment = Math.min(Math.max(parseFloat(_downpayment), 0), price)
    const percentage = downpayment / price * 100
    setValues({ ...values, downpayment, percentage })
  }

  const updatePercentage = (_percentage) => {
    const percentage = Math.min(Math.max(parseFloat(_percentage), 0), 100)
    const downpayment = price * percentage / 100
    setValues({ ...values, downpayment, percentage })
  }

  return (
    <section className={`contact-formCont ${view["contact-form"]}`}>
      <div className={`contact-inputCont ${grid["col-md-6"]} ${grid["col-sm-12"]}`} onClick={() => setEngagement({innerText: "Vehicle Price"})}>
        <input className="contact-input" id="price" name="price" readOnly
          placeholder="" value={price} />
        <label for="firstName">VEHICLE PRICE $</label>
      </div>

      <div className={`contact-inputCont ${grid["col-md-6"]} ${grid["col-sm-12"]}`} onClick={() => setEngagement({innerText: "Trade In Value"})}>
        <input className="contact-input" name="tradein" type="number" autocomplete="off"
          value={values.tradein} onChange={updateTradein} />
        <label for="lastName">TRADE IN VALUE $</label>
      </div>

      <div className={`contact-inputCont contact-phone ${grid["col-md-6"]} ${grid["col-sm-12"]}`} onClick={() => setEngagement({innerText: "Interest Rate"})}>
        <select className="contact-input" id="rate" name="rate"
          value={values.rate} onChange={e => updateState(e.target.value, "rate")} >
          <option value="0">Excellent</option>
          <option value="1">Great</option>
          <option value="2">Very Good</option>
          <option value="3">Good</option>
          <option value="4">Fair</option>
          <option value="5">Poor</option>
        </select>
        <label for="phoneNumber">INTEREST RATE</label>
      </div>

      <div className={`contact-inputCont ${grid["col-md-6"]} ${grid["col-sm-12"]}`} onClick={() => setEngagement({innerText: "Loan Term"})}>
        <select className="contact-input" id="months" name="months"
          onChange={e => updateMonths(e.target.value)} value={month}>
          {
            months.map(function (m, idx) {
              if (idx == month) {
                return <option value={idx} selected>{`${m} months`}</option>;
              } else {
                return <option value={idx}>{`${m} months`}</option>;
              }
            })
          }
        </select>
        <label for="email">LOAN TERM</label>
      </div>

      <div className={`contact-inputCont ${grid["col-md-6"]} ${grid["col-sm-12"]}`} onClick={() => setEngagement({innerText: "Down Payment"})}>
        <input className="contact-input" name="downpayment" type="number" autocomplete="off"
          onChange={e => updateDownpayment(e.target.value)} value={Math.ceil(values.downpayment)} />
        <label for="comments">DOWN PAYMENT $</label>
      </div>

      <div className={`contact-inputCont ${grid["col-md-6"]} ${grid["col-sm-12"]}`} onClick={() => setEngagement({innerText: "Down Payment"})}>
        <input className="contact-input" name="percentage" type="number" autocomplete="off"
          onChange={e => updatePercentage(e.target.value)} value={Math.ceil(values.percentage)} />
        <label for="comments">DOWN PAYMENT %</label>
      </div>

      <div className="contact-inputCont contact-border" onClick={() => { setEngagement({innerText: "Apply Now"}) }}>
        <button className={`contact-button ${view["action-btn"]}`}
          onClick={props.nextPage} >
          APPLY NOW
        </button>
      </div>
    </section>
  )
}